import React from 'react';
import './LoadingSpinner.scss';

interface LoadingSpinnerProps {
  /** Message under the logo. Defaults to a neutral "Loading…". */
  message?: string;
  /**
   * Visual theme:
   *  - 'light' (default): logo on the app's light background — used pre-login
   *    (Login redirect / silent token, Bootstrap config+MSAL init) so it matches
   *    the Login page and #app-initial-loader.
   *  - 'brand': dashboard teal gradient with the logo on a white badge — used
   *    post-login (ProtectedRoute) so the loader matches the dashboard hero theme.
   */
  variant?: 'light' | 'brand';
}

/**
 * Shared full-viewport brand loader: a gently pulsing Facilon logo over a ring.
 * Single source of truth for every loading gap. Kept visually in sync with the
 * JS-free #app-initial-loader in public/index.html.
 */
export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  message = 'Loading…',
  variant = 'light',
}) => {
  return (
    <div className={`loading-spinner-container ${variant === 'brand' ? 'brand' : ''}`}>
      <div className="loading-brand">
        <div className="loading-ring"></div>
        <img className="loading-logo" src="/assets/images/logo.png" alt="Facilon" />
      </div>
      <p>{message}</p>
    </div>
  );
};
